module.exports = __webpack_public_path__ + "static/media/model-d-max-08.1d5caf33.webp";